module.exports = __webpack_public_path__ + "static/media/LT1-BG1.6a35ef1a.jpg";